import { Component as ComponentContainer } from '@styles/layout';
import { TestimonialComponent } from '@model/content';
import { TestimonialHeroContainer } from '@components/testimonial-hero';
import { TestimonialContentContainer } from '@components/content/destination';
import { isTourTripType } from '@util/tours';

export const TestimonialsContainer = ({ path, tripType, testimonials, data, destination }: TestimonialComponent) => {
  if (isTourTripType(tripType)) {
    return (
      <TestimonialContentContainer path={path} tripType={tripType} destination={destination} testimonials={data} />
    );
  }
  return (
    <ComponentContainer isEdgeToEdge>
      <TestimonialHeroContainer testimonials={testimonials} />
    </ComponentContainer>
  );
};
